(function() {
  if (window.__CA_META_ATTRIBUTION_TRACKER__) return;
  window.__CA_META_ATTRIBUTION_TRACKER__ = true;

  var STORAGE_KEY = 'ca_attribution_v2';
  var LEGACY_STORAGE_KEY = 'ca_meta_attribution_v1';
  var SESSION_UPDATE_KEY = 'ca_attr_cart_updated_v2';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var MAX_HISTORY = 5;
  var MAX_HISTORY_LENGTH = 3500;

  var TRACKED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'campaign_name',
    'adset_name',
    'ad_name',
    'placement',
    'dct',
    'product',
    'creator',
    'destination',
    'ad_format',
    'source_ad_type',
    'product_set_id',
    'product_set',
    'media_type',
    'variant',
    'ca_platform',
    'ca_channel',
    'ca_campaign_id',
    'ca_campaign_name',
    'ca_adset_id',
    'ca_adset_name',
    'ca_adgroup_id',
    'ca_adgroup_name',
    'ca_ad_id',
    'ca_ad_name',
    'ca_creative_id',
    'ca_creative',
    'ca_placement',
    'ca_product',
    'ca_creator',
    'ca_destination',
    'fbclid',
    'gclid',
    'gbraid',
    'wbraid',
    'ttclid',
    'msclkid',
    'epik',
    'twclid',
    '_kx'
  ];

  function now() {
    return Date.now();
  }

  function readCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return '';
    return parts.pop().split(';').shift() || '';
  }

  function trimValue(value, maxLength) {
    value = String(value || '');
    return value.length > maxLength ? value.slice(0, maxLength) : value;
  }

  function currentUrlWithoutHash() {
    return window.location.href.split('#')[0];
  }

  function externalReferrer() {
    if (!document.referrer) return '';
    try {
      var referrer = new URL(document.referrer);
      if (referrer.hostname && referrer.hostname !== window.location.hostname) {
        return trimValue(document.referrer.split('#')[0], 1000);
      }
    } catch (e) {}
    return '';
  }

  function normalizeSource(value) {
    value = String(value || '').toLowerCase();
    if (/fb|facebook|instagram|ig|meta/.test(value)) return 'meta';
    if (/google|adwords|youtube/.test(value)) return 'google';
    if (/tiktok|tt/.test(value)) return 'tiktok';
    if (/pinterest|pin/.test(value)) return 'pinterest';
    if (/klaviyo|email|sms/.test(value)) return 'klaviyo';
    if (/bing|microsoft/.test(value)) return 'microsoft';
    return value;
  }

  function inferPlatform(data) {
    var source = normalizeSource(data.ca_platform || data.utm_source || data.source);
    if (source) return source;
    if (data.fbclid || data.fbc || /facebook|instagram|fbclid/i.test(data.landing_url || '')) return 'meta';
    if (data.gclid || data.gbraid || data.wbraid) return 'google';
    if (data.ttclid) return 'tiktok';
    if (data.epik) return 'pinterest';
    if (data.msclkid) return 'microsoft';
    if (data._kx) return 'klaviyo';

    var referrer = data.referrer || '';
    if (/facebook|instagram|fb\.com|l\.instagram/i.test(referrer)) return 'meta';
    if (/google|youtube/i.test(referrer)) return 'google';
    if (/tiktok/i.test(referrer)) return 'tiktok';
    if (/pinterest/i.test(referrer)) return 'pinterest';
    return '';
  }

  function isPaidTouch(data) {
    var medium = String(data.utm_medium || data.medium || '').toLowerCase();
    var source = inferPlatform(data);
    var contentId = String(data.ca_ad_id || data.ad_id || data.utm_content || '');
    var hasAdId = /^\d{8,}$/.test(contentId);
    var hasCampaignId = !!(data.ca_campaign_id || data.campaign_id || data.ca_adset_id || data.adset_id);
    if (/paid|cpc|ppc|cpm|display|shopping|paid_social|paid_search/.test(medium)) return true;
    if (data.gclid || data.gbraid || data.wbraid || data.ttclid || data.msclkid || data.epik) return true;
    return ['meta', 'google', 'tiktok', 'pinterest', 'microsoft'].indexOf(source) !== -1 && (hasCampaignId || hasAdId);
  }

  function refreshPaidFlag(touch) {
    if (!touch) return touch;
    touch.is_paid = isPaidTouch(touch);
    return touch;
  }

  function sanitizeStored(stored) {
    if (!stored) return {};
    if (!Array.isArray(stored.history)) stored.history = [];
    stored.history = stored.history.map(refreshPaidFlag);
    stored.first_touch = refreshPaidFlag(stored.first_touch);
    stored.last_click = refreshPaidFlag(stored.last_click);
    stored.last_paid_touch = refreshPaidFlag(stored.last_paid_touch);
    if (stored.last_paid_touch && !stored.last_paid_touch.is_paid) stored.last_paid_touch = null;
    if (!stored.last_paid_touch) {
      for (var i = stored.history.length - 1; i >= 0; i--) {
        if (stored.history[i] && stored.history[i].is_paid) {
          stored.last_paid_touch = stored.history[i];
          break;
        }
      }
    }
    return stored;
  }

  function field(data, primary, fallback) {
    return data[primary] || data[fallback] || '';
  }

  function compactTouch(data) {
    var platform = inferPlatform(data);
    var source = data.utm_source || platform || data.source || '';
    var medium = data.utm_medium || data.medium || '';
    var touch = {
      platform: platform,
      source: source,
      medium: medium,
      campaign_id: data.ca_campaign_id || data.campaign_id || data.utm_campaign || '',
      campaign_name: data.ca_campaign_name || data.campaign_name || '',
      adset_id: data.ca_adset_id || data.adset_id || data.utm_term || '',
      adset_name: data.ca_adset_name || data.adset_name || '',
      adgroup_id: data.ca_adgroup_id || data.adgroup_id || '',
      adgroup_name: data.ca_adgroup_name || data.adgroup_name || '',
      ad_id: data.ca_ad_id || data.ad_id || data.utm_content || '',
      ad_name: data.ca_ad_name || data.ad_name || '',
      creative_id: data.ca_creative_id || data.creative_id || '',
      creative: data.ca_creative || data.creative || data.dct || '',
      placement: data.ca_placement || data.placement || '',
      dct: data.dct || '',
      product: data.ca_product || data.product || '',
      creator: data.ca_creator || data.creator || '',
      destination: data.ca_destination || data.destination || '',
      ad_format: data.ad_format || '',
      source_ad_type: data.source_ad_type || '',
      product_set_id: data.product_set_id || '',
      product_set: data.product_set || '',
      media_type: data.media_type || '',
      variant: data.variant || '',
      fbclid: data.fbclid || '',
      fbp: data.fbp || '',
      fbc: data.fbc || '',
      gclid: data.gclid || '',
      gbraid: data.gbraid || '',
      wbraid: data.wbraid || '',
      ttclid: data.ttclid || '',
      msclkid: data.msclkid || '',
      epik: data.epik || '',
      twclid: data.twclid || '',
      kx: data._kx || '',
      landing_url: data.landing_url || '',
      referrer: data.referrer || '',
      touched_at: data.captured_at || new Date().toISOString(),
      is_paid: isPaidTouch(data)
    };

    Object.keys(touch).forEach(function(key) {
      touch[key] = trimValue(touch[key], key === 'landing_url' || key === 'referrer' ? 1000 : 250);
    });
    return touch;
  }

  function queryData() {
    var params = new URLSearchParams(window.location.search);
    var data = {};
    var hasTrackedParams = false;

    TRACKED_PARAMS.forEach(function(key) {
      var values = params.getAll(key);
      var value = values.length ? values[values.length - 1] : '';
      if (value) {
        data[key] = trimValue(value, key === 'fbclid' ? 500 : 250);
        hasTrackedParams = true;
      }
    });

    var fbp = readCookie('_fbp');
    var fbc = readCookie('_fbc');
    if (!fbc && data.fbclid) {
      fbc = 'fb.1.' + Math.floor(now() / 1000) + '.' + data.fbclid;
    }
    if (fbp) data.fbp = trimValue(fbp, 250);
    if (fbc) data.fbc = trimValue(fbc, 600);

    var referrer = externalReferrer();
    if (referrer) data.referrer = referrer;

    if (hasTrackedParams || referrer || data.fbp || data.fbc) {
      data.landing_url = trimValue(currentUrlWithoutHash(), 1000);
      data.captured_at = new Date().toISOString();
    }

    return {
      data: data,
      hasTrackedParams: hasTrackedParams,
      hasTouch: hasTrackedParams || !!referrer
    };
  }

  function migrateLegacy() {
    try {
      var legacy = JSON.parse(localStorage.getItem(LEGACY_STORAGE_KEY) || '{}');
      if (!legacy.updated_at || now() - legacy.updated_at > MAX_AGE_MS) return {};
      var stored = { history: [] };
      if (legacy.first_touch) {
        stored.first_touch = compactTouch(legacy.first_touch);
        stored.history.push(stored.first_touch);
      }
      if (legacy.last_touch) {
        stored.last_click = compactTouch(legacy.last_touch);
        if (stored.last_click.is_paid) stored.last_paid_touch = stored.last_click;
        stored.history.push(stored.last_click);
      }
      if (!stored.last_paid_touch && stored.first_touch && stored.first_touch.is_paid) {
        stored.last_paid_touch = stored.first_touch;
      }
      return sanitizeStored(stored);
    } catch (e) {
      return {};
    }
  }

  function loadStored() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      if (!stored.updated_at || now() - stored.updated_at > MAX_AGE_MS) return migrateLegacy();
      return sanitizeStored(stored);
    } catch (e) {
      return migrateLegacy();
    }
  }

  function saveStored(stored) {
    try {
      stored.updated_at = now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {}
  }

  function touchFingerprint(touch) {
    return [
      touch.platform,
      touch.source,
      touch.medium,
      touch.campaign_id,
      touch.adset_id,
      touch.adgroup_id,
      touch.ad_id,
      touch.creative,
      touch.landing_url
    ].join('|');
  }

  function addHistory(stored, touch) {
    stored.history = stored.history || [];
    var fingerprint = touchFingerprint(touch);
    var last = stored.history[stored.history.length - 1];
    if (!last || touchFingerprint(last) !== fingerprint) {
      stored.history.push(touch);
    } else {
      stored.history[stored.history.length - 1] = touch;
    }
    while (stored.history.length > MAX_HISTORY) stored.history.shift();
  }

  function mergeAttribution() {
    var incoming = queryData();
    var stored = loadStored();

    if (incoming.hasTouch) {
      var touch = compactTouch(incoming.data);
      if (!stored.first_touch) stored.first_touch = touch;
      stored.last_click = touch;
      if (touch.is_paid) stored.last_paid_touch = touch;
      addHistory(stored, touch);
    } else if (!stored.last_click && (incoming.data.fbp || incoming.data.fbc)) {
      var cookieTouch = compactTouch(incoming.data);
      stored.last_click = cookieTouch;
      if (!stored.first_touch) stored.first_touch = cookieTouch;
    }

    if (!stored.first_touch && stored.last_paid_touch) stored.first_touch = stored.last_paid_touch;
    if (!stored.last_paid_touch && stored.first_touch && stored.first_touch.is_paid) stored.last_paid_touch = stored.first_touch;
    if (stored.first_touch || stored.last_click || stored.last_paid_touch) saveStored(stored);

    return { stored: stored, shouldUpdateCart: incoming.hasTouch };
  }

  function stringifyHistory(history) {
    var compact = (history || []).map(function(touch) {
      return {
        p: touch.platform,
        s: touch.source,
        m: touch.medium,
        c: touch.campaign_id,
        cn: touch.campaign_name,
        as: touch.adset_id,
        ag: touch.adgroup_id,
        a: touch.ad_id,
        an: touch.ad_name,
        cr: touch.creative,
        dct: touch.dct,
        prod: touch.product,
        dest: touch.destination,
        paid: !!touch.is_paid,
        at: touch.touched_at
      };
    });
    return trimValue(JSON.stringify(compact), MAX_HISTORY_LENGTH);
  }

  function cartAttributesFrom(stored) {
    var first = stored.first_touch || {};
    var lastClick = stored.last_click || stored.last_paid_touch || first;
    var lastPaid = stored.last_paid_touch || (lastClick.is_paid ? lastClick : {});
    var attrs = {};

    function set(name, value) {
      if (value !== undefined && value !== null && String(value) !== '') {
        attrs[name] = String(value);
      }
    }

    function setOrClear(name, value) {
      attrs[name] = value !== undefined && value !== null && String(value) !== '' ? String(value) : '';
    }

    function setTouch(prefix, touch) {
      setOrClear(prefix + '_platform', touch.platform);
      setOrClear(prefix + '_source', touch.source);
      setOrClear(prefix + '_medium', touch.medium);
      setOrClear(prefix + '_campaign_id', touch.campaign_id);
      setOrClear(prefix + '_campaign_name', touch.campaign_name);
      setOrClear(prefix + '_adset_id', touch.adset_id);
      setOrClear(prefix + '_adset_name', touch.adset_name);
      setOrClear(prefix + '_adgroup_id', touch.adgroup_id);
      setOrClear(prefix + '_adgroup_name', touch.adgroup_name);
      setOrClear(prefix + '_ad_id', touch.ad_id);
      setOrClear(prefix + '_ad_name', touch.ad_name);
      setOrClear(prefix + '_creative_id', touch.creative_id);
      setOrClear(prefix + '_creative', touch.creative);
      setOrClear(prefix + '_placement', touch.placement);
      setOrClear(prefix + '_dct', touch.dct);
      setOrClear(prefix + '_product', touch.product);
      setOrClear(prefix + '_creator', touch.creator);
      setOrClear(prefix + '_destination', touch.destination);
      setOrClear(prefix + '_landing_url', touch.landing_url);
      setOrClear(prefix + '_referrer', touch.referrer);
      setOrClear(prefix + '_at', touch.touched_at);
    }

    setTouch('ca_first', first);
    setTouch('ca_last_paid', lastPaid);
    setTouch('ca_last_click', lastClick);

    setOrClear('ca_platform', lastPaid.platform);
    setOrClear('ca_dct', lastPaid.dct);
    setOrClear('ca_product', lastPaid.product);
    setOrClear('ca_creator', lastPaid.creator);
    setOrClear('ca_destination', lastPaid.destination);
    setOrClear('ca_ad_format', lastPaid.ad_format);
    setOrClear('ca_source_ad_type', lastPaid.source_ad_type);
    setOrClear('ca_product_set_id', lastPaid.product_set_id);
    setOrClear('ca_product_set', lastPaid.product_set);
    setOrClear('ca_media_type', lastPaid.media_type);
    setOrClear('ca_variant', lastPaid.variant);
    setOrClear('ca_utm_source', lastPaid.source);
    setOrClear('ca_utm_medium', lastPaid.medium);
    setOrClear('ca_utm_campaign', lastPaid.campaign_id);
    setOrClear('ca_utm_content', lastPaid.ad_id);
    setOrClear('ca_utm_term', lastPaid.adset_id || lastPaid.adgroup_id);
    setOrClear('ca_placement', lastPaid.placement);
    setOrClear('ca_campaign_name', lastPaid.campaign_name);
    setOrClear('ca_adset_name', lastPaid.adset_name || lastPaid.adgroup_name);
    setOrClear('ca_ad_name', lastPaid.ad_name);
    setOrClear('ca_fbclid', lastPaid.fbclid || first.fbclid);
    setOrClear('ca_fbp', lastPaid.fbp || first.fbp);
    setOrClear('ca_fbc', lastPaid.fbc || first.fbc);
    setOrClear('ca_gclid', lastPaid.gclid || first.gclid);
    setOrClear('ca_gbraid', lastPaid.gbraid || first.gbraid);
    setOrClear('ca_wbraid', lastPaid.wbraid || first.wbraid);
    setOrClear('ca_ttclid', lastPaid.ttclid || first.ttclid);
    setOrClear('ca_msclkid', lastPaid.msclkid || first.msclkid);
    setOrClear('ca_epik', lastPaid.epik || first.epik);
    set('ca_landing_url', first.landing_url || lastPaid.landing_url || lastClick.landing_url);
    set('ca_last_url', lastPaid.landing_url || lastClick.landing_url);
    set('ca_last_click_url', lastClick.landing_url);
    set('ca_captured_at', first.touched_at || lastPaid.touched_at || lastClick.touched_at);
    set('ca_last_touch_at', lastPaid.touched_at || lastClick.touched_at);
    set('ca_last_click_at', lastClick.touched_at);
    set('ca_click_history', stringifyHistory(stored.history));

    return attrs;
  }

  function updateCartAttributes(stored, force) {
    if (!window.fetch || !stored || (!stored.first_touch && !stored.last_click && !stored.last_paid_touch)) return;
    if (!force && sessionStorage.getItem(SESSION_UPDATE_KEY) === '1') return;

    var attrs = cartAttributesFrom(stored);
    if (!Object.keys(attrs).length) return;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      keepalive: true
    })
      .then(function() {
        try { sessionStorage.setItem(SESSION_UPDATE_KEY, '1'); } catch (e) {}
      })
      .catch(function() {});
  }

  function scheduleCartAttributeUpdate(stored, force) {
    var run = function() {
      updateCartAttributes(stored, force);
    };

    if (force) {
      run();
      return;
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 3000 });
      return;
    }

    if (document.readyState === 'complete') {
      window.setTimeout(run, 500);
    } else {
      window.addEventListener('load', function() {
        window.setTimeout(run, 500);
      }, { once: true });
    }
  }

  var merged = mergeAttribution();
  scheduleCartAttributeUpdate(merged.stored, merged.shouldUpdateCart);

  document.addEventListener('click', function(event) {
    var target = event.target && event.target.closest && event.target.closest('a, button, input');
    if (!target) return;
    var href = target.getAttribute && target.getAttribute('href');
    var isCheckout =
      (href && /\/checkout\b/.test(href)) ||
      target.name === 'checkout' ||
      target.getAttribute('data-testid') === 'Checkout-button';
    if (isCheckout) scheduleCartAttributeUpdate(loadStored(), true);
  }, true);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches) return;
    if (form.matches('form[action*="/cart"], form[action*="/checkout"]')) {
      scheduleCartAttributeUpdate(loadStored(), true);
    }
  }, true);
})();
